import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const CreateAssetTypeViewTopBar = memo(() => {
	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link from="/$organizationId/settings/asset-types/create" to="/$organizationId/settings/asset-types">
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Asset types
					</Button>
				</Link>
			}
		/>
	)
})
CreateAssetTypeViewTopBar.displayName = "CreateAssetTypeViewTopBar"
